import { render, staticRenderFns } from "./PrintHoldTicketTable.vue?vue&type=template&id=07a9320d&scoped=true&"
import script from "./PrintHoldTicketTable.vue?vue&type=script&lang=ts&"
export * from "./PrintHoldTicketTable.vue?vue&type=script&lang=ts&"
import style0 from "./PrintHoldTicketTable.vue?vue&type=style&index=0&id=07a9320d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a9320d",
  null
  
)

export default component.exports